import {StockMovementEditor} from "./CreateOpeningStock.jsx";
export default function TransferStuff(props){return <StockMovementEditor {...props} kind="transfer"/>;}
